<template>
  <div>
  <v-expansion-panels v-model="expandedPanel">
    <v-expansion-panel
      v-for="(certificate, index) in certificates"
      :key="certificate.id"
      :class="{ 'expanded-panel': expandedPanel === index }"
    >
      <v-expansion-panel-header>
        <div class="d-flex align-center justify-space-between w-100">
             <!-- Arrow only if has children -->
              <v-icon v-if="hasChildren(certificate)" >
                {{ expandedPanel === index ? 'mdi-chevron-down' : 'mdi-menu-down' }}
              </v-icon>
          <span>{{ serverTranslate(certificate.name) }}</span>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click.stop="certificate.active = !certificate.active"
                :color="certificate.active=='1' ? 'success' : ''"
                large
              >
                {{ certificate.active =="1" ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}
              </v-icon>
            </template>
            <span>{{ certificate.active =="1" ? $t('DEACTIVATE') : $t('ACTIVATE') }}</span>
          </v-tooltip>
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content v-if="hasChildren(certificate)">
        <v-list>
          <CertificatePanel
           :items="certificate.children"
          />
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

   <div class="text-center mt-4 mb-2">
    <v-btn color="primary" class="mr-2" @click="updateCertificateData()"> {{ $t("SAVE") }}</v-btn>
    <v-btn color="darken3" class="white--text mr-2" @click.native="close">{{ $t("CANCEL") }}</v-btn>
    <v-btn color="success" class="mr-2 ml-2"  @click="updateActiveCertificate"> {{ $t("ACTIVE_ALL") }}</v-btn>
    <v-btn color="error" @click="updateInactiveCertificate"> {{ $t("DEACTIVE_ALL") }}</v-btn>
  </div>
       <pr-confirmDialog ref="confirm"></pr-confirmDialog>
  </div>
</template>
<style scoped>

.expanded-panel .v-expansion-panel-header {
  background-color: #f0f8ff !important; /* only when expanded */
}
</style>
<script>
import serverTranslationsMixin from "@/mixins/serverTranslations";
import globalMethodsMixin from "@/mixins/globalMethods";
import CertificatePanel  from "@/components/modules/administration/SystemRules/CertificatePanel.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog"; // adjust the path
export default {
   components: {
    CertificatePanel,
     "pr-confirmDialog": ConfirmDialog
  },
   mixins: [serverTranslationsMixin,globalMethodsMixin],
  data() {
    return {
      expandedPanel: null, // only one expanded panel index
      certificates: [],
      originalCertificates: [] // <- hold the original data

    }
  },
   created() {
      this.initialize();
    },
  methods: {
      hasChildren(cerificate) {
    return cerificate.children && cerificate.children.length > 0;
  },
    initialize(){
              this.$http.get("/api/general_data/list_certificates_applying_rule/").then(
        response => {
        this.certificates = response.data.data;
        this.originalCertificates = JSON.parse(JSON.stringify(response.data.data)); // deep copy


        },
        err => {
           this.showToasted("error", err.response.data.message)
        }
      );
    },
    confirmAndUpdateCertificates({ messageKey, activeValue = null, applyStatusChange = false }) {
          this.$refs.confirm
            .open("CONFIRMATION_MESSAGE", messageKey)
            .then(confirm => {
              if (confirm) {
                // Apply status change to all if needed
                if (applyStatusChange && activeValue !== null) {
                  this.certificates.forEach(certificate => {
                    this.setActiveRecursively(certificate, activeValue);
                  });
                }

                // Send update request
                this.$http
                  .put("/api/general_data/update_certificates_applying_rule/", this.certificates)
                  .then(response => {
                    this.showToasted("success", response.data.message);
                    this.initialize();
                  })
                  .catch(err => {
                    this.showToasted("error", err.response.data.message);
                  });
              }
            });
        },
    isCertificatesChanged() {
        return JSON.stringify(this.certificates) !== JSON.stringify(this.originalCertificates);
      },
     updateCertificateData(confirmationMessage="CERTIFICATES_SAVE_CONFIRMATION") {
          if (!this.isCertificatesChanged()) {
          this.showToasted("info", this.$t("NO_CHANGES_TO_SAVE"));
          return;
        }

        this.confirmAndUpdateCertificates({
          messageKey: confirmationMessage,
          applyStatusChange: false
        });


    },
    close() {
           this.$refs.confirm
        .open("CONFIRMATION_MESSAGE", "CONFIRM_CANCEL")
        .then(confirm => {
          if (confirm) {
            this.initialize();
          }
        });
    },
     updateActiveCertificate() {
         this.confirmAndUpdateCertificates({
          messageKey: "ACTIVATION_CERTIFICATES_CONFIRMATION",
          activeValue: "1",
          applyStatusChange: true
        });
    },

    updateInactiveCertificate() {
     this.confirmAndUpdateCertificates({
          messageKey: "DEACTIVATION_CERTIFICATES_CONFIRMATION",
          activeValue: "0",
          applyStatusChange: true
        });
    },
      // Recursive function to update a certificate and its children
      setActiveRecursively(certificate, activeValue) {
        certificate.active = activeValue;
        if (certificate.children && certificate.children.length) {
          certificate.children.forEach(child => {
            this.setActiveRecursively(child, activeValue);
          });
        }
      },
  }
}
</script>